import React, { type FC } from 'react';
import { Grid, GridColumn } from '@atlaskit/page';
import PageHeader from '../../page-header/view.tsx';
import AuthenticationPanel from '../authentication-panel/index.tsx';

export type Props = {
	showDefaultTitle: boolean;
	onAuthenticate: () => Promise<void>;
};

export const AuthenticationPanelWithBreadcrumbs: FC<Props> = ({
	onAuthenticate,
	showDefaultTitle,
}) => (
	<Grid>
		<GridColumn>
			{/* @ts-expect-error - TS2769 - No overload matches this call. */}
			<PageHeader truncateTitle showDefaultTitle={showDefaultTitle} />
			<AuthenticationPanel onAuthenticate={onAuthenticate} />
		</GridColumn>
	</Grid>
);

export default AuthenticationPanelWithBreadcrumbs;
